import React, { useContext } from "react";
import { Grid } from "@material-ui/core";
import DevIcon from "devicon-react-svg";
import "../CSS/Skills.css";
import springboot from "../Assets/spring-boot.svg";
import typescript from "../Assets/typescript.png";
import reduxLogo from "../Assets/redux.png";

import { AppContext } from "./Context.js";

const skillArr = [
  {
    label: "Angular",
    icon: "angular_simple",
  },
  {
    label: "Springboot",
    icon: springboot,
  },
  {
    label: "Typescript",
    icon: typescript,
  },
  {
    label: "JavaScript",
    icon: "javascript",
  },
  {
    label: "Java",
    icon: "java",
  },
  {
    label: "Python",
    icon: "python",
  },
  {
    label: "React",
    icon: "react",
  },
  {
    label: "NodeJS",
    icon: "nodejs",
  },
  {
    label: "HTML",
    icon: "html5",
  },
  {
    label: "CSS3",
    icon: "css3",
  },
  {
    label: "MySQL",
    icon: "mysql",
  },
  {
    label: "MongoDB",
    icon: "mongodb",
  },
  {
    label: "Git",
    icon: "git",
  },
  {
    label: "npm",
    icon: "npm",
  },
  {
    label: "Visual Studio Code",
    icon: "visualstudio",
  },
  {
    label: "Sass",
    icon: "sass",
  },
  {
    label: "Redux",
    icon: <img src={reduxLogo} alt="Redux" style={{ width: "30%" }} />,
  },
];
export default function Skills({ id }) {
  const [itemSnapped] = useContext(AppContext);
  return (
    <React.Fragment>
      <Grid container spacing={0} id={id}>
        <div className={itemSnapped === "Skills" ? "vanish" : "skills"}>
          <Grid item md={12} sm={12} xs={12} className="bgs">
            <Grid item md={12} sm={12} xs={12}>
              <div className="titleDiv">
                <h1
                  style={{
                    color: "#867ae9",
                    paddingLeft: "15px",
                  }}
                  className="sectionsTitle"
                >
                  Skills
                </h1>
              </div>
            </Grid>
            <div className="skillsBox">
              <Grid container spacing={4}>
                {skillArr.map((skill) => (
                  <Grid
                    key={skill.label}
                    container
                    item
                    md={2}
                    sm={4}
                    xs={6}
                    style={{ paddingTop: "5%" }}
                  >
                    <Grid item md={12} sm={12} xs={12}>
                      {skill.icon === springboot ? (
                        <img
                          src={springboot}
                          alt=""
                          style={{
                            marginBottom: "10px",
                            width: "30%",
                            filter: "invert(1)",
                          }}
                        />
                      ) : skill.icon === typescript ? (
                        <img
                          src={typescript}
                          alt=""
                          style={{
                            marginBottom: "10px",
                            width: "30%",
                            filter: "invert(1)",
                          }}
                        />
                      ) : (
                        <DevIcon
                          icon={skill.icon}
                          style={{ fill: "white", width: "30%" }}
                        />
                      )}
                    </Grid>
                    <Grid item md={12} sm={12} xs={12}>
                      <span
                        style={{
                          color: "#cbd1dd",
                          fontSize: "25px",
                          fontFamily: "DrStrange",
                        }}
                      >
                        {skill.label}
                      </span>
                    </Grid>
                  </Grid>
                ))}
              </Grid>
            </div>
          </Grid>
        </div>
      </Grid>
    </React.Fragment>
  );
}
